import { all, put, takeEvery } from 'redux-saga/effects'
import _ from 'lodash'

import {
    activeTab,
    tabsAddTabFromOld,
    removeTab,
    removeTabFromOld,
} from '../../../scenes/Gnosus/components/Tabs/actions'

import { SOCKET_ON_MESSAGE } from '../constants'

function* onMessageFromOld(_action) {
    const type = _.get(_action, 'data.type', null)
    const entId = _.get(_action, 'data.content.entId', null)
    const module = _.get(_action, 'data.content.module', null)
    const name = _.get(_action, 'data.content.name', '')

    if (!entId || !module) return null

    if (type === 'WS_OPEN_TAB') {
        const moduleName = module === 'report2' ? 'report' : module
        yield put(activeTab(entId, moduleName))
    }

    if (type === 'WS_ADD_TAB_FROM_OLD') {
        const moduleName = module === 'report' ? 'reportOld' : module
        yield put(tabsAddTabFromOld(entId, moduleName, name))
    }

    if (type === 'WS_CLOSE_TAB_FROM_OLD') {
        const moduleName = module === 'report' ? 'reportOld' : module
        yield put(removeTabFromOld(entId, moduleName))
    }

    if (type === 'WS_CLOSE_TAB') {
        const moduleName = module === 'report2' ? 'report' : module
        yield put(removeTab(entId, moduleName))
    }

    return null
}

export default function* workspaceTabsSaga() {
    yield all([takeEvery(SOCKET_ON_MESSAGE, onMessageFromOld)])
}
